// Service presets offered in the Log Quote / New Quote modals.
//
// DP-specific for now. Once TenantConfig exposes a per-tenant `services`
// list (Worker side), read from there instead and delete this constant —
// it's the single source of truth so both quote entry points stay in sync.
export const DEFAULT_SERVICE_PRESETS = [
  'Premium Detail',
  'Interior Detail',
  'Exterior Detail',
  'Ceramic Coating',
  'Maintenance Wash',
] as const;
